import React from 'react';
import AnimateHeight from 'react-animate-height';
import './Faq.scss';
import { Container } from 'components/UI/Container/Container';
import { Grid, GridRow, GridCol } from 'components/UI/Grid';
import { PrismicHTML } from 'components/Prismic';
import { BooleanOptionType, PrismicRichTextFieldType, PrismicTitleFieldType, ThemeOptionType } from '../types';
import { SupportedPrismicSlicesEnum } from '../enums';

type Item = {
    faq_question: PrismicRichTextFieldType;
    faq_answer: PrismicRichTextFieldType;
};

type FaqProps = {
    slice: {
        type: SupportedPrismicSlicesEnum.faq;
        primary: {
            faq_title: PrismicTitleFieldType;
            faq_note: PrismicRichTextFieldType;
            faq_theme: ThemeOptionType;
            faq_multiple_open_items: BooleanOptionType;
        };
        fields: Item[];
    };
};

type FaqState = {
    openItems: number[];
};

const AccordionSection = (section: { isOpen: boolean; onClick: (event: any) => void; theme: string; item: Item }) => {
    const { faq_question: question, faq_answer: answer } = section.item;
    return (
        <div className={`FaqItem FaqItem--${section.theme.toLowerCase()}`} onClick={section.onClick}>
            <PrismicHTML
                content={question}
                className={`FaqItem-questionText FaqItem-questionText--${section.theme.toLowerCase()}`}
            />
            {section.isOpen ? (
                <span className="FaqItem-icon  FaqItem-icon--open" />
            ) : (
                <span className="FaqItem-icon  FaqItem-icon--closed" />
            )}
            <AnimateHeight className="FaqItem-heightWrapper" duration={500} height={section.isOpen ? 'auto' : 0}>
                <PrismicHTML
                    content={answer}
                    className={`FaqItem-questionText FaqItem-answer--${section.theme.toLowerCase()}`}
                />
            </AnimateHeight>
        </div>
    );
};

class Faq extends React.Component<FaqProps, FaqState> {
    constructor(props: FaqProps) {
        super(props);

        this.state = {
            openItems: [],
        };
    }

    handleClick = (i: number) => () => {
        this.setState((state: FaqState) => {
            let openItems = [...state.openItems];

            if (openItems.includes(i)) {
                // Remove the item from the openItems array if already in the array
                openItems.splice(openItems.indexOf(i), 1);
            } else {
                if (this.props.slice.primary.faq_multiple_open_items === 'Yes') {
                    // If multiple items can be open, simply add the new one
                    openItems.push(i);
                } else {
                    // Otherwise, remove any other open ones
                    openItems = [i];
                }
            }

            return { openItems };
        });
    };
    renderItems = () => {
        return this.props.slice.fields.map(
            (item, index) =>
                item.faq_question &&
                item.faq_answer && (
                    <AccordionSection
                        key={index}
                        isOpen={this.state.openItems.includes(index)}
                        onClick={this.handleClick(index)}
                        theme={this.props.slice.primary.faq_theme}
                        item={item}
                    />
                ),
        );
    };
    render() {
        const {
            slice: {
                primary: { faq_note: note, faq_title: title, faq_theme: theme },
            },
        } = this.props;
        return (
            <div className={`Faq Faq--${theme.toLowerCase()}`}>
                <Container size="md">
                    {title && (
                        <Grid>
                            <GridRow horizontalAlign={'h-center'} verticalAlign={'v-center'}>
                                <GridCol colSize={`10`} offsetSize={`0`} mobileColSize={'12'}>
                                    <PrismicHTML
                                        content={title}
                                        className={`Faq-note Faq-title--${theme.toLowerCase()}`}
                                    />
                                    {this.renderItems()}
                                    <PrismicHTML
                                        content={note}
                                        className={`Faq-note Faq-note--${theme.toLowerCase()}`}
                                    />
                                </GridCol>
                            </GridRow>
                        </Grid>
                    )}
                </Container>
            </div>
        );
    }
}

export { Faq, FaqProps };
